import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FrameComponent from "./FrameComponent";

const DrawerTablet = ({ onClose }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add("animate");
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);

  const onPrimaryButtonContainerClick = useCallback(() => {
    navigate("/desktop-19");
  }, [navigate]);

  const onSecondaryButtonHomeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onSecondaryButtonSignUpContainerClick = useCallback(() => {
    navigate("/signup");
  }, [navigate]);

  const onSecondaryButtonMyAccountContainerClick = useCallback(() => {
    navigate("/signup");
  }, [navigate]);

  const onSecondaryButtonMyPostsContainerClick = useCallback(() => {
    navigate("/signup1");
  }, [navigate]);

  return (
    <div
      className="relative rounded-tl-21xl rounded-tr-none rounded-b-none bg-sky-blue-100 w-[484px] h-full flex flex-col pt-16 px-0 pb-0 box-border items-center justify-between [&.animate]:animate-[0.25s_ease_0s_1_normal_forwards_slide-in-right] opacity-[0] max-w-[90%] overflow-auto text-left text-base text-dark font-footnote"
      data-animate-on-scroll
    >
      <div className="self-stretch flex flex-col py-0 px-8 items-center justify-start gap-[32px] z-[0]">
        <img
          className="relative w-[153.75px] h-[33.36px]"
          alt=""
          src="/union1.svg"
        />
        <div className="self-stretch rounded-15xl flex flex-col items-center justify-center gap-[8px]">
          <div className="self-stretch rounded-11xl overflow-hidden flex flex-row items-start justify-center border-[1px] border-solid border-lightgray-100">
            <input
              className="[border:none] font-footnote text-base bg-light flex-1 box-border overflow-hidden flex flex-row p-4 items-center justify-start max-w-[300px] border-r-[1px] border-solid border-black"
              type="text"
              placeholder="Search by Sensitivity"
            />
            <div className="self-stretch bg-light box-border w-[200px] flex flex-row p-4 items-center justify-start gap-[20px] max-w-[200px] ml-[-1px] border-l-[1px] border-solid border-lightgray-100">
              <label className="cursor-pointer relative" htmlFor="CitySearch">
                New York City
              </label>
              <img
                className="relative rounded-sm w-4 h-[12.39px]"
                alt=""
                src="/vector-412.svg"
              />
            </div>
          </div>
          <div
            className="self-stretch rounded-21xl bg-gold flex flex-row py-4 px-8 items-center justify-center cursor-pointer hover:bg-goldenrod-100 active:bg-darkkhaki"
            onClick={onPrimaryButtonContainerClick}
          >
            <b className="relative">Search</b>
          </div>
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <div
            className="self-stretch rounded-21xl bg-light flex flex-row py-4 px-8 items-center justify-center cursor-pointer hover:bg-gray-200 active:bg-darkkhaki md:hover:bg-gray-200"
            onClick={onSecondaryButtonHomeContainerClick}
          >
            <b className="relative">Home</b>
          </div>
          <div
            className="self-stretch rounded-21xl bg-light flex flex-row py-4 px-8 items-center justify-center cursor-pointer hover:bg-gray-200 active:bg-lightgray-200"
            onClick={onSecondaryButtonSignUpContainerClick}
          >
            <b className="relative">Sign In / Up</b>
          </div>
          <div
            className="self-stretch rounded-21xl bg-light flex flex-row py-4 px-8 items-center justify-center cursor-pointer hover:bg-gray-200 active:bg-darkkhaki"
            onClick={onSecondaryButtonMyAccountContainerClick}
          >
            <b className="relative">My Account</b>
          </div>
          <div
            className="self-stretch rounded-21xl bg-light flex flex-row py-4 px-8 items-center justify-center cursor-pointer hover:bg-gray-200 active:bg-darkkhaki"
            onClick={onSecondaryButtonMyPostsContainerClick}
          >
            <b className="relative">My Posts</b>
          </div>
        </div>
      </div>
      <div className="self-stretch rounded-tl-none rounded-tr-21xl rounded-b-none bg-light flex flex-col py-4 px-8 items-center justify-start z-[1]">
        <FrameComponent
          frameDivPosition="unset"
          frameDivBorderRadius="64px"
          frameDivWidth="64px"
          frameDivHeight="64px"
          frameDivBoxSizing="border-box"
          frameDivCursor="unset"
        />
      </div>
      <div className="my-0 mx-[!important] absolute top-[24px] left-[27px] rounded-11xl flex flex-row p-0.5 items-center justify-center z-[2]">
        <img
          className="relative w-[13.31px] h-[13.31px]"
          alt=""
          src="/union2.svg"
        />
      </div>
    </div>
  );
};

export default DrawerTablet;
